import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import { ReactComponent as Close } from "assets/icons/close.svg";

const sideVariants = {
  closed: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: -1,
    },
  },
  open: {
    transition: {
      staggerChildren: 0.2,
      staggerDirection: 1,
    },
  },
};
const Wrapper = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  z-index: 999;
  main {
    display: flex;
    justify-content: flex-end;
  }
  aside {
    background-color: white;
    width: 18.75rem;
    height: 100vh;
    position: relative;
  }
  .container {
    margin: 4.5rem 1.4rem;
  }
  .btn-container {
    position: fixed;
  }
  .container a {
    color: #f9fafb;
    text-decoration: none;
    font-size: 1.75rem;
    font-weight: 600;
    display: block;
    margin: 20px;
  }
`;
function SideMenu({
  show,
  toggle,
  title,
  children,
  width = 540,
  customHeader,
}: {
  show: boolean;
  toggle: () => void;
  title?: string | React.ReactNode;
  children: React.ReactNode;
  width?: string | number;
  customHeader?: React.ReactNode;
}) {
  return (
    <AnimatePresence>
      {show && (
        <Wrapper onClick={toggle}>
          <main>
            {show && (
              <motion.aside
                onClick={(e) => e.stopPropagation()}
                initial={{ width: 0 }}
                animate={{
                  width: width,
                }}
                exit={{
                  width: 0,
                  transition: { duration: 0.3 },
                }}
              >
                <motion.div
                  initial="closed"
                  animate="open"
                  exit="closed"
                  variants={sideVariants}
                >
                  {customHeader ? (
                    customHeader
                  ) : (
                    <header className="p-6 font-semibold flex justify-between border-b border-b-[#DDDDDD]">
                      <h2>{title}</h2>
                      <button onClick={toggle}>
                        <Close width={20} stroke="#8D8E92" />
                      </button>
                    </header>
                  )}
                  {children}
                </motion.div>
              </motion.aside>
            )}
          </main>
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

export default SideMenu;
